import React, { useEffect } from 'react';
import { X, Bell, Info } from 'lucide-react';

const NotificationsPanel = ({ isOpen, onClose, notifications, onMarkRead }) => {
  useEffect(() => {
    if (isOpen && notifications.some(n => !n.isRead) && onMarkRead) {
      onMarkRead('admin'); 
    }
  }, [isOpen, notifications.length]);

  if (!isOpen) return null;

  return (
    <>
      <div 
        className="messaging-backdrop"
        onClick={onClose}
      />
      
      <div className="messaging-drawer">
        <div className="messaging-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', flex: 1 }}>
            <div className="messaging-avatar" style={{ background: 'var(--health-cyan)' }}>
              <Bell size={18} color="black" />
            </div>
            <div style={{ flex: 1 }}>
              <h3 className="messaging-header-name">Centro de Notificaciones</h3>
              <p className="messaging-header-role">Comunicados del sistema</p>
            </div>
          </div>
          <button onClick={onClose} className="messaging-icon-btn">
            <X size={20} />
          </button>
        </div>

        <div className="messaging-chat-area" style={{ padding: '1rem' }}>
          <div className="messaging-chat-pattern" />

          {notifications.length === 0 ? (
            <div className="messaging-empty-state">
              <Bell size={48} strokeWidth={1} style={{ color: 'rgba(255,255,255,0.15)', marginBottom: '1rem' }} />
              <p>No tienes notificaciones nuevas.</p>
            </div>
          ) : (
            notifications.map(msg => {
              const content = msg.content.replace('SYSTEM_BROADCAST::', '');
              return (
                <div 
                  key={msg.id} 
                  style={{
                    background: 'rgba(255,255,255,0.05)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    borderRadius: '12px',
                    padding: '1.2rem',
                    marginBottom: '1rem',
                    position: 'relative',
                    transition: 'all 0.2s',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
                  }}
                >
                  {!msg.isRead && (
                    <div style={{
                      position: 'absolute',
                      top: '1.2rem',
                      right: '1.2rem',
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      background: 'var(--health-cyan)',
                      boxShadow: '0 0 10px var(--health-cyan)'
                    }} />
                  )}
                  
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.8rem', color: 'var(--text-muted)' }}>
                    <Info size={16} />
                    <span style={{ fontSize: '0.85rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px' }}>
                      Plataforma
                    </span>
                    <span style={{ fontSize: '0.75rem', marginLeft: 'auto' }}>
                      {new Date(msg.createdAt).toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })} • {new Date(msg.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </span>
                  </div>
                  
                  <div style={{ color: 'white', lineHeight: '1.5', fontSize: '0.95rem' }}>
                    {content}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </>
  );
};

export default NotificationsPanel;
